var exports = {
  "kL": "ChannelChatLayout.module__container___MWVrcF",
  "Yx": "ChannelChatLayout.module__messagesArea___MWVrcF",
  "gA": "ChannelChatLayout.module__textareaArea___MWVrcF",
};

module.exports = exports;
